import React from 'react';
import BaseIcon from './BaseIcon.js';

const IconNo = function ({ size }) {
  return (
    <BaseIcon viewBox="0 0 24 24" size={size}>
      <g>
        <g>
          <circle fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" cx="12" cy="12" r="11.2" />
        </g>
      </g>
    </BaseIcon>
  );
}

export default IconNo;